// global feature flags
module.exports = {
  NEW_PERSONAL_COUNTER: {
    flag: 'eng-new-personal-counter',
    enabled: 'tree-based',
    disabled: 'default',
  },
  PRIVACY_PROXY: {
    flag: 'sea-privacy-proxy',
    enabled: 'st_cloudflare',
    disabled: 'st_control',
  },
  PRIVACY_PROXY_MS: {
    flag: 'sea-privacy-proxy-ms',
    enabled: 'st_cloudflare',
    disabled: 'st_control',
  },
  FAVICONS: {
    flag: 'cs-favicons',
    enabled: 'enabled',
    disabled: 'disabled',
  },
  SEARCH_SHORTCUTS: {
    flag: 'cs-460-shortcuts',
    variant_a: 'st_ab_shortcuts_a',
    variant_b: 'st_ab_shortcuts_b',
    variant_c: 'st_ab_shortcuts_c',
    control_1: 'st_ab_shortcuts_ctrl1',
    control_2: 'st_ab_shortcuts_ctrl2',
  },
  AD_QUALITY_FEEDBACK: {
    flag: 'cs-577-ad-quality-feedback',
    enabled: 'enabled',
    disabled: 'disabled',
  },
};
